import { Wrench } from 'lucide-react';

export function FallbackDependencyFailed() {
  return (
    <div className="flex size-full flex-col items-center justify-center rounded-lg border-2 border-dashed border-gray-200 bg-gray-50 p-8 text-center">
      <Wrench className="mb-4 size-10 text-gray-400" aria-hidden="true" />
      <h2 className="mb-2 text-lg font-semibold text-gray-700">
        Problem loading system logs
      </h2>
      <div className="space-y-2 text-gray-500">
        <p>
          We couldn&apos;t connect to the logs service. This may be due to
          maintenance or a network issue.
        </p>
        <p>
          Please try again later or contact support if the problem persists.
        </p>
      </div>
    </div>
  );
}
